import { z } from 'zod';

import { getOneOnOneActiveArchiveCountApi, getOneOnOneLandingPageApi } from '../apis';
import { OneOnOneLandingPageRequestI } from '../interfaces/common';

export const oneOnOneLandingPageDetailsValidator = z.object({
  isArchivedList: z.boolean(),
  employeeId: z.number(),
  selectedCohortId: z.number().nullable(),
});

export const getLandingPageData = async ({
  isArchivedList,
  dateRange,
  selectedCohortId,
  isShowReportees,
  employeedId,
}: OneOnOneLandingPageRequestI) => {
  try {
    const res = await getOneOnOneLandingPageApi({
      isArchivedList,
      dateRange,
      selectedCohortId,
      isShowReportees,
      employeedId,
    });
    const data = res.entity;
    return data;
  } catch (error) {
    console.error('Error while fetching one-on-one landing page data', error);
  }
};

export const getLandingPageactiveArchiveCount = async ({ selectedCohortId, dateRange }) => {
  try {
    const res = await getOneOnOneActiveArchiveCountApi({ selectedCohortId, dateRange });
    const data = res.entity;
    return data;
  } catch (error) {
    console.error('Error while fetching one-on-one Active-Archive count', error);
  }
};
